import { memo } from "react";

/**
 * Skip to content link for keyboard navigation accessibility
 * Allows keyboard users to skip directly to main content
 */
export const SkipToContent = memo(function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      Hopp til hovedinnhold
    </a>
  );
});
